import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import { navy } from '../colors';
/*::
import type { Node } from 'react';

export type IconDirection = 'left' | 'right' | 'top' | 'bottom';

export type IconProps = {|
  color?: string,
  width?: number,
  height?: number,
  direction?: IconDirection,
|}
*/

var WDZ = 10;
var HGT = 6;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var Arrow = function Arrow(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? navy() : _ref$color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'bottom' : _ref$direction,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "direction", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;

  var directionToDegree = function directionToDegree(dir
  /*: IconDirection */
  )
  /*: ?string */
  {
    switch (dir) {
      case 'left':
        return 'rotate(90deg)';

      case 'right':
        return 'rotate(270deg)';

      case 'top':
        return 'rotate(180deg)';

      case 'bottom':
        return 'rotate(0deg)';

      default:
        return 'rotate(0deg)';
    }
  };

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem",
      transform: directionToDegree(direction)
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M5.70851 5.67566L9.90117 0.963234C10.0183 0.823921 9.99878 0.650931 9.99878 0.520281C9.99878 -0.00231816 9.42903 1.79299e-07 9.28468 1.79299e-07L0.715334 1.79299e-07C0.593303 1.79299e-07 0.00119305 -0.00228767 0.00119305 0.520281C0.00119305 0.650931 -0.0182343 0.823951 0.0988436 0.963234L4.29147 5.67563C4.61647 6.06242 5.00001 5.99559 5.00001 5.99559C5.00001 5.99559 5.38355 6.06245 5.70851 5.67566Z" // eslint-disable-line max-len
    ,
    fill: color
  }));
};

export default Arrow;